import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HistoryPlaceholder from '../../../../components/BlockEmptyHistory';
import HistoryItem from '../../../../components/HistoryItem/HistoryItem';
import PeriodFilter from '../../../../components/PeriodFilter/PeriodFilter';
import AppConfig from '../../../../config';
import HelperService from '../../../../services/HelperService';
import RequestService from '../../../../services/RequestService';

import './AccountHistory.scss';

const { routes } = AppConfig;

const FIRST_ITEM_MAP = 0;
const SECOND_ITEM_MAP = 1;
const COUNT_LOAD = 5;

const sort = { by: 'Created', desc: true };

const AccountHistory = ({ AddressId }) => {
	const language = useSelector(state => state?.localization?.lang);
	const [data, setData] = useState();
	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [stop, setStop] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(null);
	const obserfRef = useRef(null);

	const navigate = useNavigate();

	const GetTransationByCurrency = async (newPage = page, period = filterPeriod) => {
		setLoading(true);
		setPage(newPage + 1);

		const dateFrom = HelperService.formatDate(period?.[0] || '', '-', 10, '', true, true);
		const dateTo = HelperService.formatDate(period?.[1] || '', '-', 10, 'T23:59:59.99999', true, true);

		const res = await RequestService.GetTransationByCurrency(
			0,
			AddressId,
			page,
			COUNT_LOAD,
			dateFrom,
			dateTo,
			'',
			sort
		);

		if (res.Transactions?.length === 0 && newPage === 1) setData(new Map());

		if (res.Transactions?.length === 0 || !res?.Transactions) return setStop(true);

		res?.Transactions &&
			setData(map => {
				const mapState = newPage === 1 ? new Map() : new Map(map);

				res.Transactions.forEach(i => {
					const key = i.Created.split('T')[0];
					const value = i;

					if (!mapState.has(key)) {
						mapState.set(key, []);
					}

					mapState.get(key).push(value);
				});

				return mapState;
			});

		setLoading(false);
	};

	useEffect(() => {
		const obserfRefCurrent = obserfRef.current;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting && !loading && !stop) {
					GetTransationByCurrency();
				}
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0.1,
			}
		);

		if (obserfRefCurrent) observer.observe(obserfRefCurrent);

		return () => {
			if (obserfRefCurrent) observer.unobserve(obserfRefCurrent);
		};
	}, [loading, stop]);

	const updateFilterPeriod = period => {
		setFilterPeriod(period);
		setStop(false);
		GetTransationByCurrency(1, period);
	};

	const changeDate = date => {
		const dateFormate = HelperService.FormatDateMonthTextDayNumber(new Date(date));
		const dateFormateArray = dateFormate.split(' ');

		return language === 'en' ? dateFormate : dateFormateArray[1] + ' ' + dateFormateArray[0];
	};

	const onHistoryItemClick = transaction => {
		navigate({ pathname: routes.transactionDetails }, { state: { transaction } });
	};

	return (
		<div className='AccountHistory'>
			{data && <PeriodFilter period={filterPeriod} onChange={updateFilterPeriod} />}
			{data ? (
				Array.from(data.entries()).map((item, i) => (
					<div className='AccountHistory-block-date' key={i}>
						<div className='date'>{changeDate(item[FIRST_ITEM_MAP])}</div>

						{item[SECOND_ITEM_MAP].map((item, i) => (
							<HistoryItem
								key={'HistoryItem' + i}
								date={item.Created}
								transactionType={item.TransactionType}
								transactuinStatus={item.TransactuinStatus}
								amount={item.Amount}
								currencyId={item.CurrencyId}
								comment={item.Comment}
								hideSymbol={true}
								onClick={() => onHistoryItemClick(item)}
							/>
						))}
					</div>
				))
			) : (
				<HistoryPlaceholder />
			)}
			{!stop && <div ref={obserfRef} style={{ height: '20px' }}></div>}
		</div>
	);
};

AccountHistory.propTypes = {
	AddressId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default AccountHistory;
